import {
  Zap, Wind, Droplets, ShieldCheck, HeartPulse, Award,
  Target, Move, Flame, Sparkles,
} from "lucide-react";

export const IMG = {
  logo: "/assets/logo.png",
  heroBg: "/assets/hero_stadium.webp",
  grip: "/assets/action_grip.webp",
  tunnel: "/assets/about_atmosphere.webp",
  match: "/assets/match_schalke.webp",
  team: "/assets/team_socks.webp",
  white: "/assets/product_white.webp",
  lime: "/assets/product_lime.webp",
  orange: "/assets/product_orange.webp",
  rail: "/assets/socks_white.webp",
  color: "/assets/socks_color.webp",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Shop", to: "/shop" },
  { label: "Über STARSOX", to: "/about" },
  { label: "Teams & Clubs", to: "/teams" },
  { label: "FAQ", to: "/faq" },
  { label: "Kontakt", to: "/contact" },
];

export const CONTACT = {
  instagram: "@starsoxofficial",
  instagramUrl: "https://instagram.com/starsoxofficial",
  email: "starsoxofficial@gmail.com",
  emailPlaceholder: false,
  phone: "017620936840",
  phoneDisplay: "0176 20936840",
  owner: "Nilay Kemer",
  street: "Mittlerer Worthhagen 65",
  city: "58507 Lüdenscheid",
  country: "Deutschland",
  website: "https://starsox.de",
};

export const PRODUCT = {
  name: "STARSOX Performance Grip Socks",
  priceCents: 999,
  price: "9,99 €",
  size: "One Size",
  fits: "EU 39–46",
  material: "85% Nylon · 10% Polyester · 5% Elastan",
  tagline: "Premium Grip-Socken für maximale Traktion, Komfort und Selbstvertrauen.",
};

export const COLORS = [
  {
    key: "white",
    label: "Weiß",
    hex: "#F4F4F5",
    img: IMG.white,
    accent: "#FFFFFF",
    words: ["Clean", "Confidence", "Control"],
    philosophy: "Klarheit. Selbstvertrauen. Kontrolle. Das Statement für pure Performance.",
  },
  {
    key: "lime",
    label: "Neon Lime",
    hex: "#CCFF00",
    img: IMG.lime,
    accent: "#CCFF00",
    words: ["Focus", "Energy", "Precision"],
    philosophy: "Fokus. Energie. Präzision. Für alle, die auffallen wollen – auf und neben dem Platz.",
  },
  {
    key: "orange",
    label: "Sunset Orange",
    hex: "#FF5E00",
    img: IMG.orange,
    accent: "#FF5E00",
    words: ["Passion", "Power", "Confidence"],
    philosophy: "Leidenschaft. Kraft. Selbstvertrauen. Der Farbton für kompromisslose Intensität.",
  },
];

export const TRUST = [
  { icon: Zap, title: "Maximaler Grip", desc: "Silikon-Pads für kompromisslose Traktion im Schuh." },
  { icon: HeartPulse, title: "Premium Komfort", desc: "Ergonomische Passform, die sich anfühlt wie ein zweites Paar Haut." },
  { icon: Wind, title: "Atmungsaktiv", desc: "Hochfunktionales Gestrick für ein trockenes Fußklima." },
  { icon: Droplets, title: "Schweißmanagement", desc: "Leitet Feuchtigkeit ab, damit dein Fuß trocken bleibt." },
  { icon: ShieldCheck, title: "Blasen-Reduktion", desc: "Reduziert Reibung und schützt deine Haut über 90 Minuten." },
  { icon: Award, title: "Hohe Langlebigkeit", desc: "Formstabile Verarbeitung – Wäsche für Wäsche." },
];

export const FEATURES = [
  "Maximaler Grip", "Kein Verrutschen", "Atmungsaktiv", "Schweißableitend",
  "Blasen-reduzierend", "Komfortable Passform", "Hohe Elastizität",
  "Perfekt für Fußball & explosive Sportarten",
];

export const COMPARISON = [
  { icon: Zap, feature: "Grip", ordinary: "Kein Halt – der Fuß rutscht im Schuh", starsox: "Silikon-Grip-Pads für maximale Traktion" },
  { icon: HeartPulse, feature: "Komfort", ordinary: "Drückt, scheuert, verrutscht", starsox: "Ergonomische Passform, weiches Premium-Gestrick" },
  { icon: Target, feature: "Performance", ordinary: "Bremst deine Bewegung aus", starsox: "Volle Kraftübertragung bei jedem Antritt" },
  { icon: Award, feature: "Langlebigkeit", ordinary: "Leiert schnell aus", starsox: "Formstabil und langlebig" },
  { icon: Wind, feature: "Atmungsaktivität", ordinary: "Fuß wird heiß und nass", starsox: "Atmungsaktiv & schweißableitend" },
  { icon: Move, feature: "Passform", ordinary: "Einheitsgröße von der Stange", starsox: "Präzise Passform für EU 39–46" },
];

export const CARE = [
  "Wäsche bei maximal 40 °C",
  "Nicht in den Trockner",
  "Farben getrennt waschen",
  "Vor dem Waschen auf links drehen",
];

export const WORN_BY = ["FC Schalke 04", "MSV Duisburg", "Sportfreunde Sümmern"];

export const FAQS = [
  { q: "Welche Größe haben die STARSOX Socken?", a: "STARSOX Performance Grip Socks gibt es in One Size und passen für EU 39–46. Das hochelastische Gestrick passt sich deiner Fußform an." },
  { q: "Für welche Sportarten sind sie geeignet?", a: "Entwickelt für Fußball und Torwarte – aber ideal für jede Sportart mit Grip und explosiven Bewegungen: Basketball, Handball, Fitness, Padel und mehr." },
  { q: "Wie funktioniert der Grip?", a: "An der Sohle sitzen präzise platzierte Silikon-Grip-Pads. Sie verhindern das Verrutschen im Schuh und sorgen für maximale Kraftübertragung bei jedem Antritt." },
  { q: "Aus welchem Material bestehen die Socken?", a: "Aus 85% Nylon, 10% Polyester und 5% Elastan – für optimale Passform, Halt und Atmungsaktivität." },
  { q: "Wie pflege ich meine STARSOX?", a: "Wäsche bei maximal 40 °C, nicht in den Trockner, Farben getrennt waschen und vor dem Waschen auf links drehen. So bleibt der Grip lange erhalten." },
  { q: "Wie hoch sind die Versandkosten?", a: "Der Versand innerhalb Deutschlands kostet 4,19 €. Ab einem Bestellwert von 50 € liefern wir kostenlos." },
  { q: "Wie lange dauert die Lieferung?", a: "Die Lieferung erfolgt in der Regel innerhalb von 2–3 Werktagen. Aktuell versenden wir ausschließlich innerhalb Deutschlands." },
  { q: "Kann ich meine Bestellung zurückgeben?", a: "Ja. Du hast ein 14-tägiges Rückgaberecht. Ungetragene Artikel im Originalzustand kannst du unkompliziert zurücksenden." },
  { q: "Bietet ihr Angebote für Teams und Vereine an?", a: "Ja! Ab 15 Paar erhältst du automatisch 10 % Teamrabatt auf deine Bestellung – der Rabatt wird direkt im Warenkorb abgezogen, ganz ohne Rabattcode oder Anfrage. Farben sind frei kombinierbar." },
  { q: "Reduzieren die Socken wirklich Blasen?", a: "Durch die präzise Passform und das reibungsarme Material wird die Blasenbildung deutlich reduziert – auch bei intensiver Belastung." },
  { q: "Sind die Socken atmungsaktiv?", a: "Ja. Das funktionale Gestrick leitet Feuchtigkeit ab und sorgt für ein trockenes, angenehmes Fußklima." },
  { q: "Wie kann ich bezahlen?", a: "Die Zahlung erfolgt sicher und verschlüsselt über unseren Zahlungsdienstleister Stripe – u. a. mit Kredit- und Debitkarte." },
];

export const MANIFESTO = [
  { no: "01", title: "Der erste Schritt", text: "Jeder große Weg beginnt mit dem ersten Schritt. STARSOX wurde für die Momente gemacht, in denen Stabilität über Sieg oder Niederlage entscheidet – vom ersten Antritt bis zum letzten Sprint." },
  { no: "02", title: "Grip ist Vertrauen", text: "Wenn dein Fuß im Schuh sitzt wie festgeschraubt, denkst du nicht mehr an deine Ausrüstung – nur noch an dein Spiel. Genau dieses Vertrauen liefert der STARSOX-Grip in jeder Bewegung." },
  { no: "03", title: "Kompromisslose Qualität", text: "Premium-Materialien, präzises Gestrick, durchdachte Passform. Wir bauen keine Socken von der Stange, sondern ein Performance-Produkt, das sich anfühlt wie eine etablierte Marke." },
  { no: "04", title: "Gemacht für Champions", text: "Von Nachwuchsakademien bis zum Amateurplatz: STARSOX ist für alle, die mehr wollen. Designed for Performance. Built for Champions." },
];

export const COLOR_ICONS = { white: Sparkles, lime: Target, orange: Flame };

export const TEAM_OFFER = {
  pairs: 15,
  price: "134,86 €",
  priceCents: 13486,
  regular: "149,85 €",
  perPair: "8,99 €",
};
